import React, { useState } from 'react';
import { Button } from 'primereact/button';
import alertaService from '../../services/Alerta/AlertaService';

/**
 * Cada apertura de una alerta por el usuario de la sesion: cuando, desde que
 * pantalla, desde donde (web, web en celular, app), IP y GPS.
 *
 * Se trae al pedirlo y no con el detalle: la mayoria de las veces basta el
 * "Abierta N veces" y no hace falta una consulta mas.
 */

export const PANTALLAS = {
    MIS_ALERTAS: 'Mis alertas',
    CONSULTA: 'Consulta',
    VIAJE: 'Revisión del viaje',
    VIAJE_ABIERTO: 'Viaje abierto',
    CAMPANITA: 'Campanita'
};

export const ORIGENES = {
    WEB: 'Web',
    WEB_MOVIL: 'Web en celular',
    APP: 'App'
};

export const GPS = {
    DENEGADA: 'permiso negado',
    NO_DISPONIBLE: 'sin señal',
    TIEMPO_AGOTADO: 'no respondió a tiempo',
    NO_SOPORTADA: 'equipo sin GPS'
};

const fecha = (v) => {
    if (!v) return '';
    const d = new Date(v);
    return isNaN(d.getTime()) ? '' : d.toLocaleString('es-EC');
};

/** El GPS de una apertura: link al mapa si hay coordenadas, o el motivo si no. */
export const UbicacionApertura = ({ a }) => {
    if (a.latitud != null && a.longitud != null) {
        const prec = a.precision != null ? ` · ±${Math.round(a.precision)} m` : '';
        return (
            <a href={`https://www.google.com/maps?q=${a.latitud},${a.longitud}`} target="_blank" rel="noreferrer">
                {Number(a.latitud).toFixed(5)}, {Number(a.longitud).toFixed(5)}{prec}
            </a>
        );
    }
    return <span className="text-color-secondary">{GPS[a.ubicacionEstado] || 'sin GPS'}</span>;
};

const HistorialAperturas = ({ monitoreoDetId, vistas }) => {
    const [abierto, setAbierto] = useState(false);
    const [filas, setFilas] = useState(null);
    const [error, setError] = useState(false);

    const alternar = async () => {
        const nuevo = !abierto;
        setAbierto(nuevo);
        if (nuevo) {
            setError(false);
            try {
                const r = await alertaService.historialVista(monitoreoDetId);
                setFilas(Array.isArray(r) ? r : []);
            } catch (e) {
                setError(true);
            }
        }
    };

    if (!vistas) return null;
    return (
        <div className="mt-1">
            <Button type="button" className="p-button-text p-button-sm p-0"
                    icon={abierto ? 'pi pi-chevron-up' : 'pi pi-chevron-down'} iconPos="right"
                    label={abierto ? 'Ocultar aperturas' : 'Ver cada apertura'} onClick={alternar} />
            {abierto && (
                <div className="mt-2" style={{ overflowX: 'auto' }}>
                    {error && <div className="text-sm text-color-secondary">No se pudo traer el historial.</div>}
                    {!error && filas === null && <div className="text-sm text-color-secondary">Cargando…</div>}
                    {!error && filas && (
                        <table className="w-full text-sm" style={{ borderCollapse: 'collapse' }}>
                            <thead>
                                <tr className="text-left text-color-secondary">
                                    <th className="py-1 pr-3">#</th>
                                    <th className="py-1 pr-3">Fecha</th>
                                    <th className="py-1 pr-3">Pantalla</th>
                                    <th className="py-1 pr-3">Desde</th>
                                    <th className="py-1 pr-3">IP</th>
                                    <th className="py-1">Ubicación</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filas.map((a, i) => (
                                    <tr key={`${a.fecha}-${i}`} style={{ borderTop: '1px solid var(--surface-border)' }}>
                                        <td className="py-1 pr-3">{filas.length - i}</td>
                                        <td className="py-1 pr-3" style={{ whiteSpace: 'nowrap' }}>{fecha(a.fecha)}</td>
                                        <td className="py-1 pr-3">{PANTALLAS[a.pantalla] || a.pantalla}</td>
                                        <td className="py-1 pr-3">{ORIGENES[a.origen] || a.origen}</td>
                                        <td className="py-1 pr-3" style={{ fontFamily: 'monospace' }}>{a.ip || '—'}</td>
                                        <td className="py-1"><UbicacionApertura a={a} /></td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </div>
            )}
        </div>
    );
};

export default HistorialAperturas;
